export const lines = {
  actions: {
    applyDiscount: 'Appliquer une remise',
    duplicate: 'Copier',
    editProduct: 'Modifier le produit',
    removeDiscount: 'Supprimer la remise',
  },
  advantage: {
    buttonLabel: 'Vérifier votre avantage',
    label: 'Votre avantage grâce à Creative Shelter',
  },
  benefit: 'Avantage',
  computerProgramAlert:
    'Vous facturez une mission logicielle ? Sélectionnez alors « Prestation programme informatique ». <faqLink>Vous voulez en savoir plus sur la facturation de missions informatiques ?</faqLink>',
  creativeWork: {
    header: 'Type de prestation',
    options: {
      CreativeComputer: {
        description: 'Vous écrivez un logiciel ou du code pour votre client.',
        label: 'Prestation programme informatique',
      },
      CreativeGeneral: {
        description: 'Vous créez une œuvre nouvelle et originale pour votre client.',
        label: 'Prestation créative',
      },
      CreativeReuse: {
        description: 'Votre client réutilise une œuvre existante que vous avez créée, ou l’utilise plus longtemps.',
        label: 'Réutilisation',
      },
      CreativeSubcontracting: {
        description: 'Vous refacturez un travail créatif qu’un autre freelance a réalisé pour vous.',
        label: 'Sous-traitance',
      },
      NonCreative: {
        description: 'Vous facturez des frais comme du matériel, une location ou des déplacements.',
        label: 'Prestation non créative',
      },
    },
    placeholder: 'Travail créatif ?',
  },
  description: {
    header: 'Description',
    placeholder: 'Description',
    placeholderProduct: 'Informations complémentaires',
  },
  discount: {
    free: 'Gratuit',
    header: 'Remise',
  },
  discountType: {
    flatRate: '€',
    percentage: '%',
  },
  lineTotal: {
    header: 'Total',
  },
  new: {
    invoiceLine: 'Ajouter une ligne de facture',
    photoAlbum: 'Ajouter un album photo',
    photoAlbumLine: 'Ajouter une ligne d’album photo',
    product: 'Ajouter un produit',
    productTooltip:
      'Découvrez <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">ici</a> ce que sont les produits !',
    quotationLine: 'Ajouter une ligne de devis',
    textLine: 'Ajouter une ligne de texte',
  },
  photoAlbum: {
    deleteDialog: {
      description: 'Voulez-vous vraiment supprimer la section « album photo » ? Cela supprime aussi toutes les lignes de cette section.',
      title: 'Supprimer l’album photo',
    },
    description: 'Ajoutez ici toutes les lignes de facture liées à l’album photo.',
    tag: 'TVA 6 %',
    tagTooltip: 'Toutes les lignes de la section album photo sont facturées à 6 % de TVA.',
    title: 'Album photo',
  },
  price: {
    header: 'Prix (hors TVA)',
    productNotSyncTooltip:
      'Le prix de votre ligne de facture diffère du prix de votre produit. En cliquant ici, vous utilisez le prix de votre produit.',
  },
  productName: {
    label: 'Produit',
    tooltip:
      'Cette ligne est basée sur un produit. Vous pouvez la modifier, mais les modifications ne sont enregistrées que sur votre facture, pas dans votre produit.',
  },
  quantity: {
    header: 'Quantité',
  },
  subtotal: 'Sous-total',
  textLine: 'Ligne de texte',
  total: 'Total',
  totalVat: 'Total TVA',
  units: {
    characters_one: 'Caractère',
    characters_other: 'Caractères',
    days_one: 'Jour',
    days_other: 'Jours',
    halfDays_one: 'Demi-journée',
    halfDays_other: 'Demi-journées',
    hours_one: 'Heure',
    hours_other: 'Heures',
    kilometers: 'Km',
    none: '—',
    placeholder: 'Sélectionner',
    words_one: 'Mot',
    words_other: 'Mots',
  },
  vat: {
    header: 'TVA',
  },
  vatExported: 'Exportation',
  vatPercentage: 'TVA ({{ percentage }} %)',
  vatRegime: {
    exceptionallyExempt: 'Exonéré de TVA',
    export: 'TVA exportation',
    shifted: 'Autoliquidation',
  },
  vatShifted: 'Autoliquidation',
  vatTooltip:
    'Sur la facture adressée à votre client, nous facturons toujours la TVA, quel que soit votre régime de TVA, car Creative Shelter est une entreprise assujettie à la TVA. <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">Pour en savoir plus, lisez ceci !</a>',
};
